import {
  Box,
  BoxProps,
  Container,
  DarkMode,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { faCheck, faClose, faGem } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import { Fragment, ReactElement } from 'react';
import { isDarkColor } from '../../../utils';
import { Icon, IconBox } from '../../Icon/Icon';
import { Logo } from '../../Logo/Logo';
import Markdown from '../../Markdown/Markdown';

const enabledIcon = (
  <IconBox size="4xs" bg="green.800" color="white" rounded="md">
    <Icon icon={faCheck} fontSize={'lg'} />
  </IconBox>
);
const disabledIcon = (
  <IconBox size="4xs" bg="red.800" color="white" rounded="md">
    <Icon icon={faClose} fontSize={'lg'} />
  </IconBox>
);

const CompareTable = ({
  heading,
  content,
  to,
  items,
  ...rest
}: CMS.CompareTable & BoxProps): ReactElement | null => {
  const isDark = rest.bgColor && isDarkColor(String(rest.bgColor));
  const ThemeWrapper = isDark ? DarkMode : Fragment;
  return (
    <Box {...rest}>
      <ThemeWrapper>
        <Container maxW="container.xl">
          <Box textAlign="center">
            <Heading as="h2" size="5xl" lineHeight="shorter" mb={6}>
              {heading}
            </Heading>
            {content && <Markdown fontSize={'xl'}>{content}</Markdown>}
          </Box>
          <Box mt={[10, 12, 16, 16]}>
            <Box overflowX="auto">
              <Table variant="unstyled">
                <Thead>
                  <Tr>
                    <Th w="full" minW={'275px'}></Th>
                    <Th textAlign="center" minW={{ base: '140px', lg: '220px' }} p={0}>
                      <Box
                        h="full"
                        border="4px solid"
                        borderBottom="0"
                        borderColor="gray.100"
                        _dark={{ borderColor: 'gray.800' }}
                        roundedTop="xl"
                        mx={'-2px'}
                        py={[6, 7]}
                      >
                        <Logo size={92} textColor={isDark ? '#fff' : undefined} />
                      </Box>
                    </Th>
                    <Th
                      textAlign="center"
                      fontSize="xl"
                      minW={{ base: '140px', lg: '220px' }}
                      py={[6, 7]}
                      color="gray.800"
                      textTransform={'none'}
                      _dark={{ color: 'gray.200' }}
                    >
                      {to}
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {items &&
                    items.map((item, i) => (
                      <Tr
                        key={i}
                        borderTop="2px solid"
                        borderColor="gray.100"
                        _dark={{ borderColor: 'gray.800' }}
                      >
                        <Td>
                          <Text fontWeight="bold">
                            {item.heading}
                            {!!item.isPayable && <Icon icon={faGem} color="yellow.400" ml={1} />}
                          </Text>
                          {!!item.description?.length && (
                            <Text
                              fontSize="sm"
                              color="gray.600"
                              _dark={{ color: 'gray.200' }}
                              mt={2}
                            >
                              {item.description}
                            </Text>
                          )}
                        </Td>
                        <Td
                          textAlign="center"
                          p={0}
                          borderX="4px solid"
                          borderColor="gray.100"
                          _dark={{ borderColor: 'gray.800' }}
                        >
                          <Box p={[5, 6, 8]}>{item.item1Enabled ? enabledIcon : disabledIcon}</Box>
                        </Td>
                        <Td textAlign="center" p={[5, 6, 8]}>
                          {item.item2Enabled ? enabledIcon : disabledIcon}
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </Box>
          </Box>
        </Container>
      </ThemeWrapper>
    </Box>
  );
};
export default CompareTable;
